import { render, staticRenderFns } from "./Transactions4.vue?vue&type=template&id=87a3d988&"
import script from "./Transactions4.vue?vue&type=script&lang=ts&"
export * from "./Transactions4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports